import * as Collapse from "../../../src/Components/Collapse/Collapse.scss";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, bool_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { classNames } from "../../Utils.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { getMaterialIcon } from "../../ViewUtils.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";


export class CollapseProps extends Record {
    constructor(InnerElementsHtml, HeadingHtml, InitiallyOpen) {
        super();
        this.InnerElementsHtml = InnerElementsHtml;
        this.HeadingHtml = HeadingHtml;
        this.InitiallyOpen = InitiallyOpen;
    }
}

export function CollapseProps$reflection() {
    return record_type("Components.Collapse.CollapseProps", [], CollapseProps, () => [["InnerElementsHtml", class_type("Fable.React.ReactElement")], ["HeadingHtml", class_type("Fable.React.ReactElement")], ["InitiallyOpen", bool_type]]);
}

export function CollapseProps_get_GetDefault() {
    return new CollapseProps(react.createElement(react.Fragment, {}), react.createElement(react.Fragment, {}), false);
}

export const collapse = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_8, children_4, children_2;
    const showInnerElementsState = react.useState(props.InitiallyOpen);
    const bottomClasses = classNames(ofArray([["collapse-component__bottom", true], ["collapse-component__bottom--show", showInnerElementsState[0]]]));
    const expanderClasses = classNames(ofArray([["collapse-component__expander", true], ["collapse-component__expander--show", showInnerElementsState[0]]]));
    const children_10 = [(children_8 = [(children_4 = [react.createElement("div", {}, props.HeadingHtml), (children_2 = [getMaterialIcon("expand_more")], react.createElement("div", {
        className: expanderClasses,
    }, ...children_2))], react.createElement("div", {
        className: "collapse-component__top",
        onClick: (_arg) => {
            showInnerElementsState[1](!(showInnerElementsState[0]));
        },
    }, ...children_4)), react.createElement("div", {
        className: bottomClasses,
    }, props.InnerElementsHtml)], react.createElement("div", {
        className: "collapse-component",
    }, ...children_8))];
    return react.createElement("div", {
        className: "collapse-wrapper",
    }, ...children_10);
}, void 0, uncurry(2, void 0), void 0, "collapse", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Collapse\\Collapse.fs", 48);

export class CollapseLeftProps extends Record {
    constructor(InnerElementsHtml, HeadingLeftHtml, HeadingRightHtml, InitiallyOpen) {
        super();
        this.InnerElementsHtml = InnerElementsHtml;
        this.HeadingLeftHtml = HeadingLeftHtml;
        this.HeadingRightHtml = HeadingRightHtml;
        this.InitiallyOpen = InitiallyOpen;
    }
}

export function CollapseLeftProps$reflection() {
    return record_type("Components.Collapse.CollapseLeftProps", [], CollapseLeftProps, () => [["InnerElementsHtml", class_type("Fable.React.ReactElement")], ["HeadingLeftHtml", class_type("Fable.React.ReactElement")], ["HeadingRightHtml", class_type("Fable.React.ReactElement")], ["InitiallyOpen", bool_type]]);
}

export function CollapseLeftProps_get_GetDefault() {
    return new CollapseLeftProps(react.createElement(react.Fragment, {}), react.createElement(react.Fragment, {}), react.createElement(react.Fragment, {}), false);
}

export const collapseLeft = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_8, children_4, children_2, children;
    const showInnerElementsState = react.useState(props.InitiallyOpen);
    const bottomClasses = classNames(ofArray([["collapse-component__bottom", true], ["collapse-component__bottom--show", showInnerElementsState[0]]]));
    const expanderClasses = classNames(ofArray([["collapse-component__expander", true], ["collapse-component__expander--show", showInnerElementsState[0]]]));
    const children_10 = [(children_8 = [(children_4 = [(children_2 = [(children = [getMaterialIcon("expand_more")], react.createElement("div", {
        className: expanderClasses,
    }, ...children)), props.HeadingLeftHtml], react.createElement("div", {
        className: "top__left",
    }, ...children_2)), props.HeadingRightHtml], react.createElement("div", {
        className: "collapse-component__top",
        onClick: (_arg) => {
            showInnerElementsState[1](!(showInnerElementsState[0]));
        },
    }, ...children_4)), react.createElement("div", {
        className: bottomClasses,
    }, props.InnerElementsHtml)], react.createElement("div", {
        className: "collapse-component",
    }, ...children_8))];
    return react.createElement("div", {
        className: "collapse-wrapper",
    }, ...children_10);
}, void 0, uncurry(2, void 0), void 0, "collapseLeft", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Collapse\\Collapse.fs", 93);

